import { render } from "./CardDetails.vue?vue&type=template&id=8d2c585c&scoped=true"
import script from "./CardDetails.vue?vue&type=script&lang=js"
export * from "./CardDetails.vue?vue&type=script&lang=js"

import "./CardDetails.vue?vue&type=style&index=0&id=8d2c585c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d2c585c"]])

export default __exports__